<div class="ppLogin_content">
  <div class="ppLogin_body">
    <div class="loginBody-content">
      <h1 class="loginTitle">
        {{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}
      </h1>
      <h2 class="loginHeader">
        {{ 'MODULES.LOGIN.SIGNUP_SUBHEADER' | transloco }}
      </h2>
      <div class="vjLoggedIn">
        <div class="vjLoggedIn_profile">
          <figure class="dsProfile">
            <img src="../../../resources/images/login/host.svg" alt="">
          </figure>
          <div>
            <p>{{ 'MODULES.LOGIN.LOGGED_IN_AS' | transloco }}</p>
            <h4 class="vjLoggedIn_profile_name">{{maskedLoginEmailAddress}}</h4>
          </div>
        </div>
        <div class="vjLoggedIn_signout">
          <p>
            {{ 'MODULES.LOGIN.NOT_YOU' | transloco }}
            <a class="dsLink" (click)="logOut()"><span class="dsLink_line">{{ 'MODULES.LOGIN.SIGN_OUT' | transloco
                }}</span></a>
          </p>
        </div>
      </div>

      <!-- Apply formGroup here -->
      <form [formGroup]="newPlayerRegistrationForm" class="signUpPage" 
      (ngSubmit)="executeNewPlayerRegistration()">
        <div class="dsFormDefault signUpForm">
          <!-- First Name -->
          <div class="dsFieldWrap">
            <label class="dsLabel">{{ 'MODULES.LOGIN.FIRST_NAME' | transloco }}<sup class="dsAsterix">*</sup></label>
            <mat-form-field>
              <input matInput formControlName="firstName" />
            </mat-form-field>
            <div class="dsErrorMsg"
              *ngIf="newPlayerRegistrationForm.get('firstName')?.touched && newPlayerRegistrationForm.get('firstName')?.hasError('required')">
              {{ 'MODULES.LOGIN.FIRST_NAME_EMPTY' | transloco }}
            </div>
            <div class="dsErrorMsg multiLineError"
              *ngIf="newPlayerRegistrationForm.get('firstName')?.touched && newPlayerRegistrationForm.get('firstName')?.hasError('minlength')">
              {{ 'MODULES.LOGIN.FIRST_NAME_MINLENGTH' | transloco }}
            </div>
            <span class="dsErrorMsg multiLineError"
              *ngIf="newPlayerRegistrationForm.get('firstName').hasError('pattern')">{{
              'MODULES.LOGIN.REGISTER_FORM_FIRST_NAME' |
              transloco }}</span>
          </div>

          <!-- Last Name -->
          <div class="dsFieldWrap">
            <label class="dsLabel">{{ 'MODULES.LOGIN.LAST_NAME' | transloco }}<sup class="dsAsterix">*</sup></label>
            <mat-form-field>
              <input matInput formControlName="lastName" />
            </mat-form-field>
            <div class="dsErrorMsg"
              *ngIf="newPlayerRegistrationForm.get('lastName')?.touched && newPlayerRegistrationForm.get('lastName')?.hasError('required')">
              {{ 'MODULES.LOGIN.LAST_NAME_EMPTY' | transloco }}
            </div>
            <div class="dsErrorMsg multiLineError"
              *ngIf="newPlayerRegistrationForm.get('lastName')?.touched && newPlayerRegistrationForm.get('lastName')?.hasError('minlength')">
              {{ 'MODULES.LOGIN.FIRST_NAME_MINLENGTH' | transloco }}
            </div>
            <span class="dsErrorMsg multiLineError"
              *ngIf="newPlayerRegistrationForm.get('lastName').hasError('pattern')">{{
              'MODULES.LOGIN.REGISTER_FORM_LAST_NAME' |
              transloco }}</span>
          </div>

          <!-- Date of Birth -->
          <div class="dsFieldWrap dsDatePicker">
            <label class="dsLabel">{{ 'MODULES.LOGIN.DATE_OF_BIRTH' | transloco }}<sup class="dsAsterix">*</sup></label>
            <mat-form-field>
              <input matInput [matDatepicker]="dob" formControlName="dob" [placeholder]="datePickerPlaceholder" [max]="maxDate" />
              <mat-datepicker-toggle matIconSuffix [for]="dob"></mat-datepicker-toggle>
              <mat-datepicker #dob></mat-datepicker>
            </mat-form-field>
            <div class="dsErrorMsg"
              *ngIf="newPlayerRegistrationForm.get('dob')?.touched && newPlayerRegistrationForm.get('dob')?.hasError('required')">
              {{ 'MODULES.LOGIN.DATE_OF_BIRTH_EMPTY' | transloco }}
            </div>
          </div>

          <!-- Gender -->
          <div class="dsFieldWrap">
            <label class="dsLabel">{{ 'MODULES.LOGIN.GENDER' | transloco }}<sup class="dsAsterix">*</sup></label>
            <mat-form-field>
              <mat-select formControlName="gender">
                <mat-option [value]="'Male'">Male</mat-option>
                <mat-option [value]="'Female'">Female</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="dsErrorMsg"
              *ngIf="newPlayerRegistrationForm.get('gender')?.touched && newPlayerRegistrationForm.get('gender')?.hasError('required')">
              {{ 'MODULES.LOGIN.GENDER_EMPTY' | transloco }}
            </div>
          </div>

          <div class="dsFieldWrap fullColumn" *ngIf="!hidePlayerPin">
            <label class="dsLabel">{{ 'MODULES.LOGIN.SET_FOUR_DIGIT_PIN' | transloco }}<sup
                class="dsAsterix">*</sup></label>
            <mat-form-field appearance="outline" floatLabel="never">
              <input [type]="showPassword ? 'text' : 'password'" formControlName="playerPin" matInput required />
              <span (click)="showPassword = !showPassword" class="eye loginIcon"
                [ngClass]="{ 'icon-pswdHide': !showPassword, 'icon-pswdShow': showPassword }"></span>
            </mat-form-field>
            <span class="dsErrorMsg"
              *ngIf="newPlayerRegistrationForm.get('playerPin').hasError('required')">{{
              'MODULES.LOGIN.PIN_NUMBER_REQUIRED' |
              transloco }}</span>
            <span class="dsErrorMsg"
              *ngIf="newPlayerRegistrationForm.get('playerPin').hasError('pattern')">{{
              'MODULES.LOGIN.PIN_NUMBER_PATTERN_ERROR' |
              transloco }}</span>
          </div>

          <div class="dsFieldWrap">
            <label class="dsLabel">{{ 'MODULES.LOGIN.COUNTRY_CODE' | transloco }}<sup class="dsAsterix">*</sup></label>
            <mat-form-field>
              <mat-select formControlName="phoneCountryCode">
                <mat-option *ngFor="let country of countries" [value]="country.dial_code">
                  <div class="countryOption">
                    <img class="countryFlag" [src]="'../../../resources/images/flags/' + country.code.toLowerCase() + '.png'"
                      [alt]="country.name">
                    <span>{{ country.name }} ({{ country.dial_code }})</span>
                  </div>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="dsErrorMsg"
              *ngIf="newPlayerRegistrationForm.get('phoneCountryCode')?.touched &&
              newPlayerRegistrationForm.get('phoneCountryCode')?.hasError('required')">
              {{ 'MODULES.LOGIN.COUNTRY_CODE_EMPTY' | transloco }}
            </div>
          </div>

          <div class="dsFieldWrap">
            <label class="dsLabel">{{ 'MODULES.LOGIN.MOBILE_NUMBER' | transloco }}<sup class="dsAsterix">*</sup></label>
            <mat-form-field>
              <input matInput formControlName="mobileNumber" maxlength="10" />
            </mat-form-field>
            <div class="dsErrorMsg"
              *ngIf="newPlayerRegistrationForm.get('mobileNumber')?.touched &&
              newPlayerRegistrationForm.get('mobileNumber')?.hasError('required')">
              {{ 'MODULES.LOGIN.MOBILE_NUMBER_EMPTY' | transloco }}
            </div>
            <span class="dsErrorMsg"
              *ngIf="newPlayerRegistrationForm.get('mobileNumber')?.touched &&
              !newPlayerRegistrationForm.get('mobileNumber')?.hasError('required') &&
              newPlayerRegistrationForm.get('mobileNumber')?.hasError('pattern')">{{
              'MODULES.LOGIN.MOBILE_NUMBER_PATTERN' |
              transloco }}</span>
            <span class="dsErrorMsg"
              *ngIf="newPlayerRegistrationForm.get('mobileNumber')?.touched &&
              !newPlayerRegistrationForm.get('mobileNumber')?.hasError('required') &&
              !newPlayerRegistrationForm.get('mobileNumber')?.hasError('pattern') &&
              (newPlayerRegistrationForm.get('mobileNumber')?.hasError('minlength') ||
              newPlayerRegistrationForm.get('mobileNumber')?.hasError('maxlength'))">{{
              'ERROR.MOBILE_LENGTH_VALIDATION' |
              transloco }}</span>
          </div>


          <!-- Address Information -->
          <h2 class="vjFormTitle">{{ 'MODULES.LOGIN.ADDRESS_INFORMATION' | transloco }}</h2>
          <div class="dsFormDefault">
            <div class="dsFieldWrap fullColumn">
              <label class="dsLabel">{{ 'MODULES.LOGIN.ADDRESS_LINE1' | transloco }}<sup class="dsAsterix">*</sup></label>
              <mat-form-field>
                <input matInput formControlName="addressLine1" />
              </mat-form-field>
              <div class="dsErrorMsg"
                *ngIf="newPlayerRegistrationForm.get('addressLine1')?.touched && newPlayerRegistrationForm.get('addressLine1')?.hasError('required')">
                {{ 'MODULES.LOGIN.ADDRESS_LINE1_EMPTY' | transloco }}
              </div>
            </div>

            <div class="dsFieldWrap fullColumn">
              <label class="dsLabel">{{ 'MODULES.LOGIN.ADDRESS_LINE2' | transloco }}</label>
              <mat-form-field>
                <input matInput formControlName="addressLine2" />
              </mat-form-field>
            </div>

            <div class="dsFieldWrap">
              <label class="dsLabel">{{ 'MODULES.LOGIN.COUNTRY' | transloco }}<sup class="dsAsterix">*</sup></label>
              <mat-form-field>
                <mat-select formControlName="country" (selectionChange)="onCountryChange($event.value)">
                  <mat-option *ngFor="let country of countryAndStatesData" [value]="country.key">
                    {{ country.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div class="dsErrorMsg"
                *ngIf="newPlayerRegistrationForm.get('country')?.touched && newPlayerRegistrationForm.get('country')?.hasError('required')">
                {{ 'MODULES.LOGIN.COUNTRY_EMPTY' | transloco }}
              </div>
            </div>

            <div class="dsFieldWrap">
              <label class="dsLabel">{{ 'MODULES.LOGIN.STATE' | transloco }}<sup class="dsAsterix">*</sup></label>
              <mat-form-field>
                <mat-select formControlName="state" [disabled]="!selectedCountry" (selectionChange)="onStateChange($event.value)">
                  <mat-option *ngFor="let state of selectedCountry?.states" [value]="state.key">
                    {{ state.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div class="dsErrorMsg"
                *ngIf="newPlayerRegistrationForm.get('state')?.touched && newPlayerRegistrationForm.get('state')?.hasError('required')">
                {{ 'MODULES.LOGIN.STATE_EMPTY' | transloco }}
              </div>
            </div>
            <div class="dsFieldWrap">
              <label class="dsLabel">{{ 'MODULES.LOGIN.CITY' | transloco }}<sup class="dsAsterix">*</sup></label>
              <mat-form-field>
                <input matInput formControlName="city" />
              </mat-form-field>
              <div class="dsErrorMsg"
                *ngIf="newPlayerRegistrationForm.get('city')?.touched && newPlayerRegistrationForm.get('city')?.hasError('required')">
                {{ 'MODULES.LOGIN.CITY_EMPTY' | transloco }}
              </div>
            </div>
            <div class="dsFieldWrap">
              <label class="dsLabel">{{ 'MODULES.LOGIN.ZIP' | transloco }}<sup class="dsAsterix">*</sup></label>
              <mat-form-field>
                <input matInput formControlName="zip" />
              </mat-form-field>
              <div class="dsErrorMsg"
                *ngIf="newPlayerRegistrationForm.get('zip')?.touched && newPlayerRegistrationForm.get('zip')?.hasError('required')">
                {{ 'MODULES.LOGIN.ZIP_EMPTY' | transloco }}
              </div>
            </div>



            <!-- Security Proof -->
            <h2 class="vjFormTitle">{{ 'MODULES.LOGIN.SECURITY_PROOF' | transloco }}</h2>
            <div class="dsFormDefault signUpForm">
              <div class="dsFieldWrap">
                <label class="dsLabel">{{ 'MODULES.LOGIN.IDENTITY_TYPE' | transloco }}<sup
                    class="dsAsterix">*</sup></label>
                <mat-form-field>
                  <mat-select formControlName="identityType">
                    <mat-option *ngFor="let identity of identTypes" [value]="identity.value">
                      {{ identity.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div class="dsErrorMsg"
                  *ngIf="newPlayerRegistrationForm.get('identityType')?.touched && newPlayerRegistrationForm.get('identityType')?.hasError('required')">
                  {{ 'MODULES.LOGIN.IDENTITY_TYPE_EMPTY' | transloco }}
                </div>
              </div>

              <div class="dsFieldWrap">
                <label class="dsLabel">{{ 'MODULES.LOGIN.IDENTITY_NUMBER' | transloco }}<sup
                    class="dsAsterix">*</sup></label>
                <mat-form-field>
                  <input matInput formControlName="identityNumber" />
                </mat-form-field>
                <div class="dsErrorMsg multiLineError"
                  *ngIf="newPlayerRegistrationForm.get('identityNumber')?.touched && newPlayerRegistrationForm.get('identityNumber')?.hasError('required')">
                  {{ 'MODULES.LOGIN.IDENTITY_NUMBER_EMPTY' | transloco }}
                </div>
              </div>

              <div class="dsFieldWrap">
                <label class="dsLabel">{{ 'MODULES.LOGIN.ISSUED_STATE' | transloco }}<sup
                    class="dsAsterix">*</sup></label>
                <mat-form-field>
                  <mat-select formControlName="issuedState">
                    <mat-option *ngFor="let state of selectedCountry?.states" [value]="state.key">
                      {{ state.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div class="dsErrorMsg"
                  *ngIf="newPlayerRegistrationForm.get('issuedState')?.touched && newPlayerRegistrationForm.get('issuedState')?.hasError('required')">
                  {{ 'MODULES.LOGIN.ISSUED_STATE_EMPTY' | transloco }}
                </div>
              </div>

              <div class="dsFieldWrap dsDatePicker">
                <label class="dsLabel">{{ 'MODULES.LOGIN.ISSUED_DATE' | transloco }}<sup class="dsAsterix">*</sup></label>
                <mat-form-field>
                  <input matInput [matDatepicker]="issuedDate" formControlName="issuedDate" [placeholder]="datePickerPlaceholder"
                    [max]="maxIssuedDate" />
                  <mat-datepicker-toggle matIconSuffix [for]="issuedDate"></mat-datepicker-toggle>
                  <mat-datepicker #issuedDate></mat-datepicker>
                </mat-form-field>
                <div class="dsErrorMsg"
                  *ngIf="newPlayerRegistrationForm.get('issuedDate')?.touched && newPlayerRegistrationForm.get('issuedDate')?.hasError('required')">
                  {{ 'MODULES.LOGIN.ISSUED_DATE_EMPTY' | transloco }}
                </div>
              </div>

              <div class="dsFieldWrap dsDatePicker">
                <label class="dsLabel">{{ 'MODULES.LOGIN.EXPIRY_DATE' | transloco }}<sup class="dsAsterix">*</sup></label>
                <mat-form-field>
                  <input matInput [matDatepicker]="expiryDate" formControlName="expiryDate" [placeholder]="datePickerPlaceholder"
                    [min]="minExpiryDate" />
                  <mat-datepicker-toggle matIconSuffix [for]="expiryDate"></mat-datepicker-toggle>
                  <mat-datepicker #expiryDate></mat-datepicker>
                </mat-form-field>
                <div class="dsErrorMsg"
                  *ngIf="newPlayerRegistrationForm.get('expiryDate')?.touched && newPlayerRegistrationForm.get('expiryDate')?.hasError('required')">
                  {{ 'MODULES.LOGIN.EXPIRY_DATE_EMPTY' | transloco }}
                </div>
              </div>

            </div>

            <!-- Footer -->
            <footer class="loginBody-footer">
              <div class="loginAction-forgotOpt">
                <div class="dsFieldWrap">
                  <mat-checkbox formControlName="acceptTerms">
                    {{ 'MODULES.LOGIN.ACCEPT' | transloco }}
                    <a class="dsLink" [href]="termsUrl" target="_blank">
                      <span class="dsLink_line">{{ 'MODULES.LOGIN.TERMS_AND_CONDITIONS' | transloco }}</span>
                    </a>
                  </mat-checkbox>
                  <div class="dsErrorMsg"
                    *ngIf="newPlayerRegistrationForm.get('acceptTerms')?.touched && newPlayerRegistrationForm.get('acceptTerms')?.hasError('requiredTrue')">
                    {{ 'MODULES.LOGIN.LOGIN_SECOND_FORM' | transloco }}
                  </div>
                </div>
              </div>
              <button type="submit" class="loginAction_btn">
                {{ 'MODULES.LOGIN.SIGN_UP' | transloco }}
              </button>

              <div class="login-options">
                <div class="login-options-link">
                  <span>{{ 'MODULES.LOGIN.ALREADY_HAVE_AN_ACCOUNT' | transloco }}</span>
                  <a class="dsLink" (click)="logOut()">
                    <span class="dsLink_line"> {{ 'MODULES.LOGIN.SIGN_IN' | transloco }}</span>
                  </a>
                </div>
              </div>

            </footer>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="login-copyright">
    {{'MODULES.LOGIN.COPYRIGHT' | transloco }}
  </div>
</div>